// Action Types
export const SET_SSO_DETAILS = "SET_SSO_DETAILS";
export const CLEAR_SSO_DETAILS = "CLEAR_SSO_DETAILS";

// Action Creator to store SSO ID and parameters
export const setSSODetails = (ssoId, ssoParams) => {
  return {
    type: SET_SSO_DETAILS,
    payload: { ssoId, ssoParams }, // Store SSO ID and Params
  };
};

// Action Creator to clear SSO details (if needed)
export const clearSSODetails = () => {
  return {
    type: CLEAR_SSO_DETAILS,
  };
};

// Initial state for SSO details
const initialState = {
  ssoId: null, // Default value for SSO ID
  ssoParams: null, // Default value for SSO Params
};

// Reducer to handle SSO details state
const ssoQueryParamsDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SSO_DETAILS:
      return {
        ...state,
        ssoId: action.payload.ssoId, // Store SSO ID
        ssoParams: action.payload.ssoParams, // Store SSO Params
      };
    case CLEAR_SSO_DETAILS:
      return {
        ...state,
        ssoId: null,
        ssoParams: null, // Reset SSO details
      };
    default:
      return state;
  }
};

export default ssoQueryParamsDetailsReducer;
